import { FC, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isEqual } from 'lodash'

import { openModal, closeModal } from 'store/actions/modals'
import useUpdateSettings from '../../UI/Filter/hooks/useUpdateSettings'
import BaseModalActions from 'components/Modals/BaseModalActions'
import { MFilters } from 'types/filterTypes'

import { t } from 'translations'

import { Button as MerinioButton, List } from 'ui'

const DropDownSavedPresetsModal: FC<{ contentName: MFilters.ContentTypes }> = ({ contentName }) => {
  const dispatch = useDispatch()

  const presetKey: MFilters.PresetKey = `saved-search-${contentName}`
  const filterKey: MFilters.FilterKey = `filter-${contentName}`

  const settings = useSelector((state: MStore.RootState) => state.settings)
  const savedOptions = useMemo(() => {
    return settings[filterKey] || {}
  }, [settings, filterKey])
  const presets: MFilters.PresetTypes<typeof filterKey> = useMemo(() => {
    return settings[presetKey] || {}
  }, [settings, presetKey])
  const presetsKeysArray = Object.keys(presets || {})

  const [selectedPreset, setSelectedPreset] = useState('')

  const { saveOptions } = useUpdateSettings(contentName)

  // Get the preset matching the savedOptions to set the right button in "active" state
  useEffect(() => {
    if (!isEqual(savedOptions, presets[selectedPreset])) setSelectedPreset('')
    Object.values(presets).forEach((preset, index) => {
      if (isEqual(preset, savedOptions)) setSelectedPreset(Object.keys(presets)[index])
    })
  }, [savedOptions, selectedPreset, presets])

  return (
    <BaseModalActions>
      <List className="pb-2">
        <List.Item className="px-0">
          {presetsKeysArray.length ? (
            presetsKeysArray.map((presetName, index) => (
              <MerinioButton
                key={index}
                className={`dropdown-item d-flex justify-content-between ${presetName === selectedPreset ? 'active' : ''}`}
                onClick={() => {
                  saveOptions(presetName === selectedPreset ? { rangeStart: '', rangeEnd: '' } : presets[presetName])
                  dispatch(closeModal())
                }}
              >
                <div className="mr-3">{presetName}</div>
                <span
                  className="pointer-cursor"
                  onClick={e => {
                    e.stopPropagation()
                    dispatch(openModal('DeleteSearchPresetConfirmationModal', { contentName, presetName, selectedPreset }))
                  }}
                >
                  <i className="fas fa-trash fa-sm" />
                </span>
              </MerinioButton>
            ))
          ) : (
            <div className="d-flex align-items-baseline mx-3 text-nowrap">
              <i className="far fa-empty-set mr-2"></i>
              {t('searchBar.NO_SAVED_PRESETS')}
            </div>
          )}
        </List.Item>
      </List>
    </BaseModalActions>
  )
}

export default DropDownSavedPresetsModal
